import React, { useState } from "react";
import BookingConfirmation from "./BookingConfirmation";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { formatTime } from "../spaBookingV2/spaBooking2a";
import { toBool } from "../../JS/utility";
import moment from "moment";

// const questionResponses = [
//   {
//     "questionId": "firstName",
//     "prompt": "First name",
//     "fieldType": "input",
//     "config": { "isRequired": true },
//     "answer": [{ "value": "John", "key": "First name" }]
//   },
//   {
//     "questionId": "lastName",
//     "prompt": "Last name",
//     "fieldType": "input",
//     "config": { "isRequired": true },
//     "answer": [{ "value": "Doe", "key": "Last name" }]
//   },
//   {
//     "questionId": "gender",
//     "prompt": "Gender",
//     "fieldType": "radio",
//     "config": {},
//     "answer": [{ "value": "Male", "key": "Gender" }]
//   },
//   {
//     "questionId": "activities",
//     "prompt": "Preferred Activities",
//     "fieldType": "multiple_select",
//     "config": {},
//     "answer": [
//       { "value": "Swimming", "key": "Preferred Activities" },
//       { "value": "Hiking", "key": "Preferred Activities" }
//     ]
//   },
//   {
//     "questionId": "email",
//     "prompt": "Email",
//     "fieldType": "input",
//     "config": {},
//     "answer": []
//   }
// ];

const WayActivity6 = (props) => {
  const {selectedData, goNextPage , goPreviousPage, currency, eventDetailedInfo, t} = props;

  const eventTotal = selectedData.priceTiers ? selectedData.priceTiers.reduce((acc, curr)=>{ return acc + (curr.quantity * curr.price)},0) : 0 ;
  const addonTotal = selectedData.addOns ? selectedData.addOns.reduce((acc, curr)=>{ return acc + (curr.quantity * curr.price)},0) : 0;

  const subtotal =  eventTotal + addonTotal;

  let eventTax =  eventDetailedInfo.taxes && Array.isArray(eventDetailedInfo.taxes) ?  eventDetailedInfo.taxes.reduce((acc, curr)=>{ 
    if(curr.includedInPrice) return acc;

    return acc + ((curr.percentage/100) * eventTotal)
  
  },0) : 0;

  eventTax = +(Number(eventTax).toFixed(2))

  let addonTax = eventDetailedInfo.addOns && Array.isArray(eventDetailedInfo.addOns) ?  eventDetailedInfo.addOns.reduce((acc, curr)=>{ 
    
    const taxOnThisAddon = curr.price && curr.taxes ? curr.taxes.reduce((acc_, curr_) =>{
      if(curr_.includedInPrice) return acc_;

      return acc_ + ((curr_.percentage/100) * curr.price)
    },0) :0;

    return acc + taxOnThisAddon;
  },0) : 0;

  addonTax = +(Number(addonTax).toFixed(2))

  const grandTotal = subtotal + eventTax + addonTax;        
                    
  return (
    <>
      <header className="inner-pages w-footer subpages">
                        <a className="button-back" onClick={goPreviousPage}></a>
                        <div className="heading align-center">
                        <div class="header">
                            <p className="text">{t("way_activity.common.header_text")}</p>
                            {/* <img src={`${CMSPath}${props.logo}`} alt="" /> */}
                        </div>
                        </div>
      </header>
    <section id="activitiespage6" className="widgets container-bg activity-listing activity-sessions-listing">

      <div className="summary-container">
        <div className="">

           <div class="widget-header-title"> {t("way_activity.summary_page.header_title")}</div>
           <div class="widget-header-subtitle"  >{t("way_activity.summary_page.header_subtitle")}</div>

          
        </div>
        <div>
          {/* <div class="field-title">Email</div>
          <div class="answer">{selectedData.defaultQuestions.purchaser.emailAddress}</div> */}

          {/* <div class="field-title">Phone</div>
          <div class="answer">{selectedData.defaultQuestions.purchaser.phoneNumber}</div> */}

          <div class="field-title">{t("way_activity.booking_overview_page.experience_name_label")}</div>
          <div class="answer">{selectedData.event.title}</div>

          { selectedData.subEvent && <>
          <div class="field-title">{t("way_activity.summary_page.sub_experience_label")}</div>
          <div class="answer">{selectedData.subEvent.title}</div>
          </>
          }

          <div class="field-title"> {t("way_activity.booking_overview_page.date_label")}</div>
          <div class="answer">{moment(selectedData.date).format(props.dateFormat.toUpperCase())}</div>

          <div class="field-title">{t("way_activity.summary_page.time_slot_label")}</div>
          <div class="answer">{`${formatTime(selectedData.timeSlot.startTime,toBool(props.timeFormat))} - ${ formatTime(selectedData.timeSlot.endTime,toBool(props.timeFormat))}`}</div>

          {
            selectedData.priceTiers && selectedData.priceTiers.some(p=>p.quantity>0) && <>
               <div class="field-title">{t("way_activity.summary_page.package_label")}</div>
               {
                selectedData.priceTiers.map(p=>{
                  if(p.quantity==0) return;
                  return <>
                    <div className="answer-multiple">
                      <div class="answer-1">{`${p.name} (x${p.quantity})`}</div>
                      <div class="answer-2">{`${currency} ${p.price}`}</div>
                    </div>
                  </>
                })
               }
               {/* <div class="answer">{selectedData.event.name}</div> */}
            </>
          }

          {
            selectedData.addOns && selectedData.addOns.some(p=>p.quantity>0) && <>
               <div class="field-title">{t("way_activity.summary_page.add_ons_label")}</div>
               {
                selectedData.addOns.map(addOn=>{
                  if(addOn.quantity==0) return;
                  return <>
                    <div className="answer-multiple">
                      <div class="answer-1">{`${addOn.label} (x${addOn.quantity})`}</div>
                      <div class="answer-2">{`${currency} ${addOn.price}`}</div>
                    </div>
                  </>
                })
               }
            </>
          }


            <>
               <div class="field-title">{t("way_activity.summary_page.subtotal_label")}</div>
                <div className="answer"> {`${currency} ${ subtotal }`} </div>
                 
            </>

            <>
               <div class="field-title">{t("way_activity.summary_page.event_tax_label")}</div>
                <div className="answer"> {`${currency} ${ eventTax }`} </div>
                 
            </>

            <>
               <div class="field-title">{t("way_activity.summary_page.addon_tax_label")}</div>
                <div className="answer"> {`${currency} ${ addonTax }`} </div>
                 
            </>


            <>
               <div class="field-title">{t("way_activity.summary_page.grand_total_label")}</div>
                <div className="answer"> {`${currency} ${
                  grandTotal
                }`} </div>
                 
            </>
         
        </div>

      <div class="row">
                        <div class="form-controls">
                          <button  
                              className="continue"
                              onClick={()=>goNextPage({type:"CREATE_BOOKING", payload:{totalTax: addonTax + eventTax , grandTotal }})} >
                              {t("way_activity.summary_page.submit_button")}
                          </button>
                        </div>
       </div>

       </div>

    </section>
    
    </>
  );
};


const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    timeFormat:
    state.store.home.clientConfig.extraConfigParam &&
    state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    serverTimeDate: state.store.home.serverTimeDate.date,
    serverDate: state.store.home.serverTimeDate,
  };
};

export default connect(mapStateToProps,
  {  })(
    withTranslation("translations")(WayActivity6)
  );

